import { jwtDecode } from 'jwt-decode';
import { create } from 'zustand/index';

import { UserDto } from '~modules/user/model';
import { client } from '~shared/api';

import { fetchAuth, fetchKeycloakToken, keycloakLogout } from '../api';

interface AuthStore {
	isPending: boolean;
	user: UserDto | null;
	error: boolean;
	login: (withInit: boolean) => void;
	logout: () => void;
}

export const authStore = create<AuthStore>(set => ({
	isPending: true,
	user: null,
	error: false,
	login: async (withInit: boolean) => {
		const keycloakToken = await fetchKeycloakToken(withInit);
		if (keycloakToken) {
			try {
				const auth = await fetchAuth(keycloakToken);
				if (auth) {
					const { groups } = jwtDecode(auth.token) as { groups: string[] };
					console.info('[auth] Groups decoded from JWT:', groups);
					auth.user.groups = groups;
					client.authorization(auth.token);
					set(old => ({ ...old, isPending: false, user: auth.user, error: false }));
					return;
				}
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				if (err.status === 401) {
					set(old => ({ ...old, isPending: false, user: null, error: true }));
					return;
				}
			}
		}
		set(old => ({ ...old, isPending: false, user: null, error: false }));
	},
	logout: async () => {
		client.authorization();
		await keycloakLogout();
		set(old => ({ ...old, user: null, isPending: false, error: false }));
	},
}));
